import { AlternativesCTASection } from "@components/alternatives/AlternativesCTASection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import ProblemSectionCard from "@components/solution/problemSectionCard";
import { BlueCardCTASection, GreyCardCTASection } from "@components/solution/solutionCTASection";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "GALLABOX FOR SALES",
    title: "Boost sales by 51% with WhatsApp automation",
    description: "Be where your customers are, and convert deals straight from WhatsApp.",
    primaryButtonText: "Start free trial",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/hero-image.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Automated chatbots and workflows",
    subtitle2: "Gallabox enables sales teams facilitate better prospect interactions and tackle pipelines efficiently",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/automated-chatbot.png",
    featureInfoList: [
        "AI chatbots for follow-ups and lead nurturing",
        "Custom workflows to help you humanize sales pitches",
        "Effective AI-written sales cadences and demo booking flows",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Personalized AI assistant",
    subtitle2: "Use GenAI to your advantage and decrease sales cycles by a long shot",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/ai-assistant.png",
    featureInfoList: ["Craft AI-driven, tailored responses", "Eliminate manual pipeline updation", "Generate better insights from your outreaches"],
};
const featureInfo3: FeatureInfo = {
    mainTitle: "Efficient sales sequences",
    subtitle2: "Use advanced drip campaigns for better engagement and increased pipeline velocity",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/sales-sequence.png",
    featureInfoList: ["Automated sales cadences and pipeline updation", "Qualify your pipeline faster", "Integrate and update CRM instantly"],
};
const featureInfo4: FeatureInfo = {
    mainTitle: "Shared team inbox ",
    subtitle2: "Decrease sales cycles and close deals faster with better collaboration capabilities",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/shared-team-inbox.png",
    featureInfoList: [
        "Unified inbox for better communication between sales development representatives and account executives",
        "Create trigger-based flows to drive better engagement",
        "Close deals faster with personalized offers",
    ],
};

const salesProductData: Array<Product> = [
    {
        title: "Keep your leads warm",
        description: "Use automated messages and AI-powered chatbots to nurture leads better and make sure your pipeline doesn’t go cold.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/rocket.svg",
    },
    {
        title: "Tailor sales outreach at scale",
        description: "Increase conversions with personalized drip campaigns — automate responses to prospect queries, and close deals faster.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/pipleline.svg",
    },
    {
        title: "Save more time with automated follow ups",
        description: "Use GenAI-based response generators and follow-up reminders to always stay on top of prospects’ minds.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/settings.svg",
    },
    {
        title: "Keep your pipeline clean",
        description: "Have a centralized database for all your sales conversations using shared team inboxes, and stay on top of every deal.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/inbox-download.svg",
    },
    {
        title: "Enrich conversations with rich media",
        description: "Deploy images, videos, voice notes, and interactive buttons to your advantage, and get your prospects down the funnel faster.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/profile-image.svg",
    },
    {
        title: "Integrate effortlessly with your tech stack",
        description: "Sync your WhatsApp Business with your CRM and 30+ other tools and manage your pipeline hassle-free.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
    },
    {
        title: "Monitor real-time analytics and data",
        description: "Make better data-driven decisions using real-time data capture, advanced reports, and actionable insights.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
    },
    {
        title: "Respond to queries instantly",
        description: "Manage prospect interactions more effectively, and drive sales faster using advanced chat workflows",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
    },
];

const sales: React.FC = () => {
    return (
        <NewLayout
            title={"WhatsApp Business Solution for Sales Teams | Gallabox"}
            description={"Close deals faster with Gallabox’s WhatsApp Business Tool—built for sales teams to automate follow-ups, manage leads, and scale conversations"}
            canonical="https://gallabox.com/solutions/sales-team"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/solution/sales/solution-sales-og.png" }}
            schema={{
                heroOrOgImageAlt: "solutions-sales-image",
                heroOrOgImageDescription: "Boost sales by 51% with WhatsApp automation",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/solution/sales/hero-image.png",
                softwareFeatureName: "solutions-sales",
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} `}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </section>
            <ProblemSectionCard />

            <section className="mx-5">
                <BlueCardCTASection />
            </section>
            <h5 className={`${container_classname} md:text-7xl text-5xl mt-40`} style={{ fontFamily: "Degular Display" }}>
                Why sales teams choose Gallabox
            </h5>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />

            <div className="mx-5">
                <AlternativesCTASection
                    ctaContent={{
                        content: "Your biggest competitive edge —  sales automation engine on WhatsApp",
                        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/interakt/wa-gallabox.png",
                        imgAlt: "sales-automations",
                        btnText: "Start for free",
                    }}
                />
            </div>

            <ProductSection productCardData={salesProductData} title="How Gallabox transforms sales teams" />
            <div className={`${container_classname} my-20`}>
                <h5 className="text-6xl mb-10" style={{ fontFamily: "Degular Display" }}>
                    Customer story
                </h5>
            </div>

            <section className="mx-5">
                <GreyCardCTASection />
            </section>

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default sales;
